const getDefaultState = () => ({
  hasAlert: false,
  message: '',
  detail: '',
  action: null,
  icon: null,

  // hasAlert: true,
  // message: 'Temperature Labels Detected',
  // action: {
  //   text: 'View',
  //   to: '/labels',
  // },
  // icon: 'mdi-thermometer-alert',
});

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    SET_BANNER_ALERT(state, {
      hasAlert, message, detail, action, icon,
    }) {
      state.hasAlert = hasAlert;
      state.message = message;
      state.detail = detail || '';
      state.action = action;
      state.icon = icon || 'mdi-alert-circle';
    },
  },
  actions: {},
  getters: {
    hasAlert(state) {
      return state.hasAlert;
    },
    getContent(state) {
      return {
        message: state.message,
        detail: state.detail,
        action: state.action,
        icon: state.icon,
      };
    },
  },
};
